import axios from "axios";

import {
  MEDIA_LIST_ATTEMPT,
  MEDIA_LIST_SUCCESS,
  MEDIA_LIST_FAILED,
  //////////////
  MEDIA_DELETE_SUCCESS,
  MEDIA_DELETE_FAILED,
  //////////////
  MEDIA_NEW_SUCCESS,
  MEDIA_NEW_LOADING,
  MEDIA_NEW_FAILED,
  //////////////
  MEDIA_RESET_LIST,
  MEDIA_REORDER_ATTEMPT,
  MEDIA_REORDER_SUCCESS,
  MEDIA_REORDER_FAILED,

} from "../types/mediaTypes";
import { config } from "../../config";

const url_api = config.api.godiway;

export function loading() {
  return {
    type: MEDIA_LIST_ATTEMPT,
  };
}

export function success(data) {
  return {
    type: MEDIA_LIST_SUCCESS,
    data: data,
  };
}

export function failed(error) {
  return {
    type: MEDIA_LIST_FAILED,
    error: error,
  };
}
///////////////////////////////////
export function successDelete(item) {
  return {
    type: MEDIA_DELETE_SUCCESS,
    item: item,
  };
}

export function failedDelete(error) {
  return {
    type: MEDIA_DELETE_FAILED,
    error: error,
  };
}
///////////////////////////////////
export function successNew(item) {
  return {
    type: MEDIA_NEW_SUCCESS,
    item: item,
  };
}
export function loadingNew(progress) {
  return {
    type: MEDIA_NEW_LOADING,
    progress: progress,
  };
}

export function failedNew(error) {
  return {
    type: MEDIA_NEW_FAILED,
    error: error,
  };
}

export function loadingReorder() {
  return {
    type: MEDIA_REORDER_ATTEMPT,
  };
}

export function successReorder(data) {
  return {
    type: MEDIA_REORDER_SUCCESS,
    data,
  };
}

export function failedReorder(error) {
  return {
    type: MEDIA_REORDER_FAILED,
    error,
  };
}
//////////////////////
export function clearMedia() {
  return {
    type: MEDIA_RESET_LIST
  };
}

export function setMediaList(list) {
  return {
    type: MEDIA_LIST_SUCCESS,
    data: {
      list,
      page: 1,
      size: list.length,
    },
  };
}

export const clearMediaList = () => async (dispatch) => {
  dispatch(clearMedia());
}

export const loadList = (data: Object) => async (dispatch) => {
  dispatch(loading());
  await axios
    .get(url_api + "media", {
      params: data.params,
      headers: { Authorization: `Bearer ${data.token}` },
    })
    .then(function (response) {
      if (response.status < 300) {
        if (response.data.status === "Success")
          dispatch(success(response.data.body));
        else dispatch(failed(response.data.body));
      } else {
        dispatch(failed("try_later"));
      }
    })
    .catch(function (error) {
      //console.log(error);
      if (error.Error) {
        dispatch(failed("try_later"));
      } else {
        dispatch(failed("try_later"));
      }
      return;
    });
};

export const deleteItem = (data: Object) => async (dispatch) => {
  try {
    const response = await axios.put(url_api + "media", data.params, {
      headers: { Authorization: `Bearer ${data.token}` },
    });

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(successDelete(response.data.body));
      return { success: true, item: response.data.body };
    }

    const error = response.data.body || "try_later";
    dispatch(failedDelete(error));
    return { success: false, error };
  } catch (error) {
    console.log(error);
    dispatch(failedDelete("try_later"));
    return { success: false, error: "try_later" };
  }
};


export const newItem = (data: Object) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch(loadingNew(0));
    const request = new XMLHttpRequest();
    request.open("POST", url_api + "media", true);
    request.setRequestHeader("Authorization", `Bearer ${data.token}`);
    request.onload = () => {
      if (request.status < 300) {
        const response = JSON.parse(request.response);
        if (response.status === "Success") {
          dispatch(successNew(response.body));
          resolve(response.body);
        } else {
          dispatch(failedNew(response.body || "try_later"));
          reject(response.body || "try_later");
        }
      } else {
        console.error(request.response);
        dispatch(failedNew("try_later"));
        reject("try_later");
      }
    };
    request.onerror = () => {
      dispatch(failedNew("try_later"));
      reject("try_later");
    };
    request.send(data.params);
    if (request.upload) {
      request.upload.onprogress = ({ total, loaded }) => {
        if (total > 0) {
          dispatch(loadingNew(loaded / total));
        }
      };
    }
  });

export const reorderList = (data: Object) => async (dispatch) => {
  dispatch(loadingReorder());

  try {
    const response = await axios.put(
      url_api + "media/order",
      {
        goder_id: data.params.goder_id,
        id: data.params.id,
        order: data.params.order,
      },
      {
        headers: { Authorization: `Bearer ${data.token}` },
      }
    );

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(successReorder(response.data.body));
      return { success: true, list: response.data.body?.list || [] };
    }

    const error = response.data.body || "try_later";
    dispatch(failedReorder(error));
    return { success: false, error };
  } catch (error) {
    dispatch(failedReorder("try_later"));
    return { success: false, error: "try_later" };
  }
};
